import { Link } from "react-router-dom";
import pure from "./higher-order/pure";
import React from "react";
import states from "../states";

export default pure(function TermsOfService() {
  var disallowedStates = states.filter(state => !state.canSignUp).map(state => state.name);
  disallowedStates.sort();
  disallowedStates = disallowedStates.join(", ");

  return (
    <div>
      <h2>
        Terms of Use
      </h2>

      <p>
        The following Terms of Use outline your obligations when using the
        {" "}

        {window.env.brandName}

        {" "}
        website. You can also review our Contest Rules, which list the official rules for

        {" "}

        {window.env.brandName}

        {" "}
        contests, and our

        {" "}

        <Link to="/privacy-policy">
          Privacy Policy
        </Link>
        , which outlines our obligations and practices towards handling any personal information that you may provide to us.
      </p>

      <h3>
        1. Acceptance of terms
      </h3>

      <p>
        The web pages available at
        {" "}

        {window.env.domains[0]}
        , which is an interactive online site (the “Contest Site”) on the World Wide Web of the Internet, (site’s address: https://

        {window.env.domains[0]}
        ) are owned and operated by Horse Racing Labs, LLC (the “Sponsor”), which operates “

        {window.env.domains[0]}
        ”. As with any online service, we must establish some basic rules designed to insure enjoyment by all of our Players (as defined below). The address for Horse Racing Labs, LLC is 714 W. Main St., Louisville, KY, 40202.
      </p>

      <p>
        Horse Racing Labs, LLC may be reached at 888-588-9070.
      </p>

      <p>
        This “Terms of Use” agreement (the “Agreement”) sets forth the terms and conditions of your use of the Contest Site. As a condition of your use of the Contest Site, including your registration for any contests operated by the Sponsor, you must accept this Agreement in its entirety. Therefore, we encourage you to carefully review and familiarize yourself with all of the terms of this Agreement. In addition, you should review this Agreement from time-to-time for any important changes as the Sponsor reserves the right to make changes at any time, in its sole discretion, for its own business purposes and as may be necessary to comply with applicable laws. This Agreement will always be accessible online via the “Terms” link at the bottom of the
        {" "}

        {window.env.domains[0]}

        {" "}
        home page.
      </p>

      <h3>
        2. Eligibility
      </h3>

      <p>
        You hereby represent and warrant that you are a natural person (corporate entities and similar organizations are not eligible to use the
        {" "}

        {window.env.brandName}

        {" "}
        Service for any purpose) and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations and warranties set forth in these terms and to abide by and comply with these terms.
      </p>

      <p>
        In order to deposit money to play paid entry games you must be able to represent and warrant that:
      </p>

      <p>
        1. you are of 18 years of age or older, and the individual who is assigned to the e-mail address submitted on your account registration form;
      </p>

      <p>
        2. you are a citizen or resident of the United States of America or Canada and that you have an address in the United States of America or Canada;
      </p>

      <p>
        3. you are physically located in the United States of America or Canada and reside in a jurisdiction in which participation in any contest you choose to participate in is not prohibited by applicable law;
      </p>

      <p>
        4. you will abide at all times by these Terms of Use and any other agreements between you and
        {" "}

        {window.env.brandName}

        {" "}
        regarding your use of the Contest Site or participation in games; and
      </p>

      <p>
        5. you are not a resident of any of the following states:
        {" " + disallowedStates}
        . The Sponsor DOES NOT offer games requiring a cash entry fee to Players accessing the Contest Site from the following states:

        {" " + disallowedStates}
        . VOID WHERE PROHIBITED OR RESTRICTED BY LAW. If you open an account and/or participate in any tournament offered on the Contest Site while located in a prohibited jurisdiction, you may be in violation of the law of such jurisdiction and will be in violation of the Terms and Conditions and subject to having your account suspended or terminated. In addition, and without limiting any rights or remedies available to the Sponsor, in the event of any violation of the Terms and Conditions, all winnings (if any) may be voided, and in the event such winnings have already been withdrawn by you, recouped by the Sponsor, at the sole and absolute discretion of the Sponsor.
      </p>

      <p>
        6. you are not subject to backup withholding tax because: (a) you are exempt from backup withholding, or (b) you have not been notified by the Internal Revenue Service (IRS) that you are subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified you that you are no longer subject to backup withholding.
      </p>

      <p>
        7. The following persons are ineligible to receive any prize offered on the Contest Site: Sponsor employees, officers, and directors (and their immediate family members) of the Sponsor, its parent companies, subsidiaries, and affiliates; and any other person with access to non-public information regarding the operation of any tournament offered on the Contest Site. For purposes of this section, immediate family members include any person permanently residing in the same household with such employee, officer, or director. Sponsor employees may use the
        {" "}

        {window.env.brandName}

        {" "}
        service for the purpose of testing the user experience, but may not withdraw money or prizes for themselves.
      </p>

      <p>
        Horse Racing Labs, LLC (“Sponsor”) customer service employees that have access to player picks are prohibited from playing online contests on other sites. Shareholders and other employees of Horse Racing Labs, LLC (“Sponsor”) who do not have access to player picks are eligible to play in qualifier contests on other sites.
      </p>

      <p>
        If you do not meet the eligibility requirements of this section, then do not use
        {" "}

        {window.env.domains[0]}

        {" "}
        . In addition to any other rights that the Sponsor may have in law or equity, the Sponsor reserves the right to suspend or terminate the account (and terminate, withhold or revoke the awarding of any prizes associated with such account) of any purported user of the

        {" "}

        {window.env.brandName}

        {" "}
        service that does not meet the foregoing requirements.

        {" "}

        {window.env.brandName}

        {" "}
        may require you to provide proof that you are eligible to participate according to this section prior to receiving a prize.
      </p>

      <p>
        You may establish only one account per person to participate in the activities offered on the
        {" "}

        {window.env.brandName}

        {" "}
        site. In the event the Sponsor discovers that you have opened more than one account per person, in addition to any other rights that the Sponsor may have, the Sponsor reserves the right to suspend or terminate any or all of your accounts and terminate, withhold or revoke the awarding of any prizes.
      </p>

      <h3>
        3. General Terms For Use Of The Site:
      </h3>

      <p>
        The Contest Site offers Users (as hereinafter defined) access to (i) information, software and content owned or licensed by the Sponsor and some third-parties (“Content Providers”), and (ii) merchandise and services offered by the Sponsor and independent merchants (“Merchants”). “Player” means any person who establishes an authorized account (“Account”) for access to and use of the Contest Site. The right to use the Contest Site is personal to the Player and a Player’s Account is not transferable.
      </p>

      <p>
        A Player may permit use of the Contest Site by other individuals in Player’s household, but the Player remains solely responsible for all charges, if any, incurred by such individuals. Except as expressly permitted in this Agreement or in applicable Rules, no portion of any information, content or software which is accessed by using the Contest Site or accessing any Sponsor website, other than information, content and software necessary for the operation of the Player’s Account (which shall be used solely in connection with Player’s Account) may be downloaded, copied, reproduced, redistributed, retransmitted, published, resold or otherwise commercially exploited by any Player
      </p>

      <p>
        If any provision of the Terms and Conditions is found to be invalid or unenforceable by a court of competent jurisdiction, such provision shall be severed from the remainder of the Terms and Conditions, which will otherwise remain in full force and effect.
      </p>

      <h3>
        4. Price, Payment &amp; Eligibility:
      </h3>

      <p>
        The Sponsor offers various horse racing contests and related products and services. Players must provide the Sponsor with valid credit card information at the time of purchase. All fees will be charged at the standard fees in effect for the products and/or services being purchased by the User. The Sponsor will not automatically renew any purchases. The Sponsor reserves the right, in its sole discretion, to determine the eligibility of each User who purchases products and/or services from the Sponsor.
      </p>

      <h3>
        5. Refunds &amp; Exchanges:
      </h3>

      <p>
        Once customers purchase a contest entry, within 30 minutes of the starting time of the contest it is non-refundable regardless of whether Player submitted their selection. If customers purchase an entry that is more than one hour away, and they wish to cancel, they can send an email to support@derbywars.com and request a cancellation. Cancellations will not be provided within 30 minutes of the starting time of the contest. Transfer of entries from one player to another player is not permitted.
      </p>

      <p>
        Shipping policy – all customer deposits are delivered immediately to the customer’s account or within one hour of the deposit.
      </p>

      <h3>
        6. Changes:
      </h3>

      <p>
        The Sponsor reserves the right, at any time, to (i) change the terms of this Agreement and/or any Rules, (ii) change the Contest Site, including eliminating or discontinuing any content or feature of the Contest Site, changing the terms of eligibility, restricting the hours of availability, or limiting the amount of use permitted by the Player, or (iii) change any fees or charges for use of the Contest Site, including instituting new or increased fees or charges for the use of the Contest Site or any features, contests, products or services offered through use of the Contest Site. Players will be given prior notice (via either postings on the Sponsor’s website or emails to Players) before any increase in existing fees or charges will become effective. All other changes shall be effective immediately unless otherwise stated. Any use of the Contest Site under a Player’s Account after notice of changes in fees and/or charges shall be deemed to constitute acceptance by the Player of the changes in those fees and/or charges.
      </p>

      <h3>
        7. Player Account Responsibility And Fees:
      </h3>

      <p>
        The Player is responsible for insuring that all use of the Contest Site under the Player’s Account (i.e., use of the Contest Site by any person using the Player’s ID and password) complies with the provisions of this Agreement and all applicable Rules. The Player is responsible for protecting and maintaining the confidentiality of his or her password. If the Player believes that his or her Player Account is no longer secure (e.g., in the event of a loss, theft or unauthorized disclosure or use of Player’s password), Player must promptly change his or her password and notify the Sponsor (as set forth in the Notices section below) to avoid liability for any unauthorized charges to Player’s Account. The Player is responsible for paying all fees and charges (plus applicable taxes) associated with the use of the Contest Site under the Player’s Account, including payment of fees or charges incurred for purchases made through the Contest Site. Unless otherwise stated, (i) payment of all fees and charges must be made by a valid, approved credit, debit or charge card, or through ACH account setup to the Player’s bank account, and (ii) all fees and charges (including, without limitation, entry, registration, and transaction fees) are non-refundable. The Player may, upon request (by electronic message or conventional mail), receive supporting information relating to fees and charges to the Player’s Account.
      </p>

      <p>
        Orders for purchases of products or services advertised on the Contest Site by the Sponsor, sponsors, advertisers, Merchants or by other third parties are subject to availability and acceptance. The Sponsor is not responsible for delivery, warranties, guarantees or other matters concerning purchases from third parties. The Player is solely responsible for and must provide all telephone and other equipment and services (including Internet access provider fees) required for access to and use of the Site.
      </p>

      <h3>
        8. Legality and Taxes:
      </h3>

      <p>
        You are subject to all laws of the city, state, federal, province and/or country in which you reside and from which you access the Contest Site and are solely responsible for obeying those laws. Access to the Contest Site may not be legal for some or all residents of, or persons present in, certain jurisdictions. You agree the Sponsor cannot be held liable if laws applicable to you restrict or prohibit your participation. The Sponsor makes no representations or warranties, express or implied, as to the lawfulness of your accessing the Contest Site or participating in any tournament offered on the Contest Site nor shall any person affiliated, or claiming affiliation, with the Sponsor have authority to make any such representations or warranties.
      </p>

      <p>
        The Sponsor reserves the right (but has no obligation to you) to monitor the location from which you access the Site and to block access from any jurisdiction in which participation or access is illegal or restricted. The Sponsor may require any participant receiving any prize to provide the Sponsor with proof that he or she is, or was at the time the subject tournament was played, eligible to participate according to the Terms and Conditions. Without limiting any contrary provision of the Terms and Conditions, if the Sponsor monitors your access or participation on the Contest Site, the Sponsor shall not be liable for the effectiveness of such monitoring. By accessing, using, or downloading in any way any materials on the Contest Site, or merely browsing the Contest Site, or creating an account and/or participating in any tournament or service offered by or through the Contest Site, you represent and warrant that you are doing so in compliance with the Terms and Conditions and agree to indemnify and hold harmless the Contest Site for any liability, claims, and damages (including attorneys’ fees) arising out of or related to your violation of the Terms and Conditions.
      </p>

      <p>
        It is the policy of the Sponsor, and in compliance with United States Internal Revenue Service regulations, the Sponsor may send an IRS Form 1099 or other appropriate form to any person who wins in excess of $600 (USD) on the site in any given year. Depending on the jurisdiction in which you reside, the Contest Site may also send you additional tax forms. In the case of contests where Players win $600 or more, we will withhold payment of funds until an IRS Form 1099 can be returned to the Sponsor. We do not withhold any taxes and you remain solely responsible for paying all federal and other taxes in accordance with the laws that apply in your local, state, province, and/or country of residence.
      </p>

      <h3>
        9. Limitations on Participation:
      </h3>

      <p>
        You may establish only one account per person to participate in the activities offered on the Contest Site. The Sponsor reserves the right to monitor all activities on the Contest Site, including without limitation, any effort to establish multiple accounts; in the event the Sponsor discovers that you have opened more than one account per person, all additional accounts will be closed without notice and continued violation will result in the termination of any and all of your accounts and the Sponsor may void any associated winnings. The Sponsor also reserves the right to deny access to anyone, including, but not limited to, those players who use proxy servers and/or IP addresses residing in certain geographical areas.
      </p>

      <p>
        The Sponsor may impose dollar amount limitations on the credit card transactions in which you engage to fund your activities on the Contest Site. The Sponsor may also impose limitations on the net dollar amount you may lose or win on the Contest Site in any calendar month; should your losses reach the designated limit, your play in the tournaments offered on the Contest Site will be restricted until the beginning of the next calendar month. The Sponsor reserves the right to change these dollar amount limitations at any time in the Sponsor’s sole and absolute discretion. The Sponsor reserves the right to set expiration dates or other limits on all player points. The Sponsor reserves the right to expire the player points balance of any dormant account. Player points is defined as any credit deposited by the Sponsor into an account, including, but not limited to, promotional credits, entry fee credits, accounting credits, prize credits, and gift credits. A dormant account shall be defined as any account that has been inactive for greater than one-hundred eighty (180) days.
      </p>

      <p>
        Prize money, player points and future tournament entries are non-transferable.
      </p>

      <h3>
        10. Odds:
      </h3>

      <p>
        The results of all tournaments offered on the Contest Site depend on the number of the players participating in such tournaments and the skill of the players in such tournaments. Precise odds of winning are therefore unavailable.
      </p>

      <h3>
        11. Entries – Minimum, Maximum and Cancelled Tournaments:
      </h3>

      <p>
        For cash tournaments, the maximum number of entries will always be fixed beforehand and will not vary. Once the tournament has reached the maximum number of entries, the tournament is closed to additional entries. Tournaments may also be scheduled with a minimum number of entries, which will represent 90% of the total entries unless otherwise specified. Until a tournament has reached the minimum number of entries, on the individual tournament page the players icon will be identified in red. Once the tournament reaches the minimum number of entries, the icon will turn blue and the tournament will proceed regardless whether the tournament reaches the maximum number of entries or not. The tournament prizes for a specific tournament will not change depending on the number of entries. Thus, the tournament has only three statuses: a) It has not yet reached the sufficient (minimum) number of entries; b) It has reached the minimum number of entries and will proceed; or c) It has reached the maximum number of entries and will proceed, but is closed to future entries. In all cases, the prizes will not change. It is only in case a), where the minimum number of entries has not yet been reached, that the tournament is subject to cancellation due to insufficient entries. If the tournament reaches the pre-determined closing time, and the minimum number of entries has not yet been reached, the tournament will be cancelled due to insufficient entries and all player entry fees shall be refunded.
      </p>

      <p>
        Qualifiers
      </p>

      <p>
        If a game is designated as a Qualifier or “Round 1” game, players attempt to “Qualify” and win an entry into a future game. Qualifying players will be automatically entered in the larger tournament that the game is a qualifier for. Should the larger “Round 2” or Qualifying game be canceled, players will receive the cash value of the entry they won to that tournament.
        {" "}

        {window.env.brandName}

        {" "}
        can not guarantee that if a player wins a Qualifier that the future qualifying game will not be canceled.
      </p>

      <h3>
        12. Prizes:
      </h3>

      <p>
        Prizes are generally cash amounts, which are deposited directly into winners’ accounts. The cash value of prizes offered in tournaments will be disclosed at the beginning of such tournaments. If a tournament has to close prematurely, such as for maintenance or technical problems, the prize for the tournament will still be paid. Except where otherwise noted, in all tournaments with actual cash entry fees, the Sponsor retains a predetermined portion of the aggregate total as a management fee and/or tournament hosting fee.
      </p>

      <p>
        Winners who wish to cash out their winning prizes can make a withdrawal request which will be made in the form of a check and sent by mail.
      </p>

      <h3>
        13. Determination of Winners:
      </h3>

      <p>
        The results and winners of each tournament offered on the Contest Site will be determined by the Sponsor, and such determinations are final. By registering and/or participating in any tournament, you agree to be bound by these determinations.
      </p>

      <h3>
        14. Game Rules:
      </h3>

      <p>
        Rules for each specific tournament offered on the Site can be found by clicking on the following link:
        {" "}

        <a href="http://blog.derbywars.com/official-rules-1/">
          Contest Rules
        </a>
      </p>

      <h3>
        15. Withdrawal Requests:
      </h3>

      <p>
        Players may request a withdrawal of funds from their available account balance at any time. Withdrawals are processed by check within five (5) business days and typically arrive within 7 to 10 days; provided, however, the Sponsor reserves the right to freeze a Player&apos;s account and/or delay a request for withdrawal of funds pending completion of any investigation of reported or suspected abuse by a user requesting withdrawal of funds. All withdrawal of funds shall be subject to the Contest Site&apos;s remedies and sanctions set forth under “Fraud and Abuse”.
      </p>

      <p>
        The Sponsor reserves the right to set a minimum check request amount of $1.00.  For withdrawals less than $1.00, players may use ACH bank transfer as a means of withdrawing funds.
      </p>

      <p>
        Please note that any checks not claimed within sixty (60) days from the date of the check will become void and the amount of the check will then be re-deposited back to your account on the Site.
      </p>

      <p>
        If a Player&apos;s account is closed by the Sponsor for a violation of the Terms and Conditions, that Player&apos;s winnings may be voided and not returned to that player. In such an event, the Sponsor, in its sole discretion, may use these winnings to defray the costs of administration and enforcement of the Terms and Conditions.
      </p>

      <h3>
        16. Fraud and Abuse:
      </h3>

      <p>
        Anyone who engages in, participates in, or displays behavior that may be interpreted, in the Sponsor’s sole and absolute discretion, as the use of unfair methods on the Contest Site, including but not limited to, the opening and/or use of multiple accounts, the use of unauthorized or altered software or hardware to assist play (including the use of bots, bot nets, collusion with bots and/or use of software or programs), intentionally poor play in certain games in order to achieve a broader competitive advantage, collusion with other players, harassment of other participants, posting of objectionable material, any breach of the Terms and Conditions, any breach of the security of your account or the Contest Site, or any other act (whether through the use of automated technology or otherwise) that unfairly alters your chance of winning or constitutes the commission of fraud (collectively, “Abuse”), you shall be subject to immediate sanction (as determined by the Sponsor in its sole and absolute discretion), including without limitation: (1) immediate termination of your account and blocking of Site access; (2) any prizes, winnings and any other representative of value (if any) that you may otherwise have been entitled to receive shall be void and/or forfeited; (3) any prizes, winnings and representative of value already received by you shall be subject to disgorgement and/or recoupment by the Sponsor; and (4) in the case of money laundering, disclosure to the FBI in accordance with the terms of certain recently passed Federal legislation. Without in any way limiting any provision of the Terms and Conditions, the Sponsor expressly reserves the right to institute or seek any injunctive relief, civil and/or criminal proceedings against you and/or any of your co-conspirators arising out of or related to your commission of Abuse, including the right to recover fees and expenses (including attorneys’ fees) and the right report you and such abuse to any and all relevant regulatory authorities or governmental agencies.
      </p>

      <h3>
        17. Accuracy of Player Information:
      </h3>

      <p>
        You represent and warrant that all information you supply to the Sponsor is complete, accurate and current. Knowingly submitting incomplete or inaccurate information, or failing to update and maintain current, complete and accurate information, may result, without limitation, in immediate termination of your account and forfeiture of any prizes or winnings.
      </p>

      <h3>
        18. Promotional Activities:
      </h3>

      <p>
        By registering for an account, you agree that the Sponsor may display your username and tournament records. By accepting any prize from the Contest Site, you agree to allow the Contest Site to print, publish, broadcast and use, worldwide, in any media and at any time, your name, picture, voice, likeness, and/or biographical information for promotional, marketing or related purposes without additional compensation.
      </p>

      <h3>
        19. Community Standards and Conduct:
      </h3>

      <p>
        You acknowledge that all content, whether publicly posted or privately transmitted, is the sole responsibility of the person from which such content originated. This means that you are entirely responsible for all content that you post, email or otherwise transmit via the Sponsor Contest Site. Sponsor does not control all of the content posted on or via the Sponsor Contest Site and, as such, does not guarantee the accuracy, integrity, completeness, non-infringement or quality of such content. You understand that by using the Sponsor Contest Site, you may be exposed to content that is offensive, indecent or objectionable. Under no circumstances will Sponsor be liable in any way for any content, including, but not limited to, for any errors or omissions in any content, or for any loss or damage of any kind incurred as a result of the use of any content posted, emailed or otherwise transmitted on or via the Sponsor Contest Site or Sponsor Services. User acknowledges that any Player Material posted, transmitted through or otherwise made available on the Contest Site may be edited, removed, modified, published, transmitted and displayed by Sponsor, and Player waives all moral rights in such Player Material.
      </p>

      <p>
        You agree to not use the Sponsor Contest Site (including, without limitation, the email service and the Forums) to:
      </p>

      <p>
        1. upload, post, email or otherwise transmit any Content that is unlawful, harmful, threatening, abusive, harassing, tortuous, defamatory, vulgar, obscene, libelous, invasive of another’s privacy, hateful, or racially, ethnically or otherwise objectionable;
      </p>

      <p>
        2. harm minors in any way;
      </p>

      <p>
        3. impersonate any person or entity, including, but not limited to, an Sponsor official, forum leader, guide or host, or falsely state or otherwise misrepresent your affiliation with a person or entity;
      </p>

      <p>
        4. forge headers or otherwise manipulate identifiers in order to disguise the origin of any Content transmitted through the Contest Site;
      </p>

      <p>
        5. solicit other players of the Sponsor Contest Site to join or become members of any online or other service;
      </p>

      <p>
        6. upload, post, email or otherwise transmit any Content that you do not have a right to transmit under any law or under contractual or fiduciary relationships (such as inside information, proprietary and confidential information learned or disclosed as part of employment relationships or under nondisclosure agreements);
      </p>

      <p>
        7. upload, post, email or otherwise transmit any Content that infringes any patent, trademark, trade secret, copyright or other proprietary rights of any party;
      </p>

      <p>
        8. upload, post, email or otherwise transmit any unsolicited or unauthorized advertising, promotional materials, “junk mail,” “spam,” “chain letters,” “pyramid schemes,” or any other form of solicitation, except in those areas that are designated for such purpose;
      </p>

      <p>
        9. upload, post, email or otherwise transmit any material that contains software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications equipment;
      </p>

      <p>
        10. disrupt the normal flow of dialogue, cause a screen to “scroll” faster than other Players of the Sponsor Services or a Sponsor Forum are able to type, or otherwise act in a manner that negatively affects other Players’ ability to engage in real time exchanges;
      </p>

      <p>
        11. interfere with or disrupt the Sponsor Services or servers or networks connected to the Sponsor Services, or disobey any requirements, procedures, policies or regulations of networks or third party providers connected to, or providing the Sponsor Services;
      </p>

      <p>
        12. intentionally or unintentionally violate any applicable local, state, national or international law;
      </p>

      <p>
        13. “stalk” or otherwise harass another member or user of the Sponsor Services; or
      </p>

      <p>
        14. collect or store personal data about other Players, or members.
      </p>

      <h3>
        20. Service Content; Software:
      </h3>

      <p>
        Sponsor shall not be responsible for any opinions, views, advice or statements posted on the Contest Site (including, without limitation, in any public posting areas of the Contest Site) by any person or entity other than an authorized Sponsor employee or spokesperson. Contest Site advertisers, Content Providers, Players, Merchants, guests, independent writers and experts are not authorized Sponsor spokespersons. Players should not rely on the opinions, views, advice or statements provided by Contest Site advertisers, Content Providers, Players, Merchants, guests, independent writers or experts for important personal decisions.
      </p>

      <p>
        Any use of Sponsor software by Players must be with Sponsor’s express written permission pursuant to this Agreement and any applicable Rules. Any right to use Sponsor software is granted only as a personal, revocable, nonexclusive and nontransferable license. Users shall not modify or copy any Sponsor software.
      </p>

      <h3>
        21. Submissions:
      </h3>

      <p>
        If, on your own or at our request, you submit content (e.g., postings to Forums, contests, emails), communications, creative suggestions, ideas, notes, drawings, or other information (collectively, “Submissions”), you hereby grant the Sponsor and its affiliates a royalty-free, perpetual, irrevocable, sub-licensable, transferable, worldwide license to use, copy, modify, incorporate into other works, display, perform, transmit and distribute such Submissions or any portion thereof, in or through any medium, whether now known or hereafter created. Sponsor shall be entitled to unrestricted use of the Submissions for any purpose whatsoever, commercial or otherwise, without compensation to the submitter. None of the Submissions shall be subject to any obligation of confidence on the part of Sponsor, and Sponsor shall not be liable for any use or disclosure of any Submissions. You represent and warrant that you own the contents of any Submission or otherwise have sufficient rights in the Submission to grant to Sponsor the license set forth above.
      </p>

      <h3>
        22. Links/External Sites and Resources:
      </h3>

      <p>
        The Sponsor Contest Site may contain, and other users or third parties may provide links to other World Wide Web sites or resources. These sites and resources are not controlled by Sponsor, and the mere existence of the link on the Sponsor Contest Site does not imply an endorsement by Sponsor. External Web sites and resources are not subject to these Terms and Conditions, or the Sponsor Privacy Policy, and may be subject to other terms and conditions or policies posted therein. Because Sponsor has no control over such sites and resources, you acknowledge and agree that Sponsor is not responsible for the availability of such external sites or resources, and does not endorse and is not responsible or liable for any Content, advertising, products, or other materials on or available from such sites or resources. You further acknowledge and agree that Sponsor shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any Content, goods or services available on or through any external site or resource. Your use of external sites or resources is at your own risk.
      </p>

      <h3>
        23. Disclaimers And Limitation Of Liability:
      </h3>

      <p>
        THE PLAYER AGREES THAT THE USE OF THE CONTEST SITE, ANY SPONSOR WEB SITE, AND ANY SOFTWARE OBTAINED THROUGH OR IN CONNECTION WITH THE CONTEST SITE (“SOFTWARE”) IS AT THE PLAYERS’S SOLE RISK. NEITHER SPONSOR, ITS CONTENT PROVIDERS NOR ANY OF THEIR RESPECTIVE MANAGERS, DIRECTORS, OFFICERS, EMPLOYEES, AGENTS OR LICENSORS WARRANT THAT THE CONTEST SITE WILL BE UNINTERRUPTED OR ERROR FREE OR THAT SOFTWARE WILL BE ERROR-FREE. NEITHER SPONSOR NOR ANY OF THE FOREGOING PERSONS MAKES ANY WARRANTY AS TO THE ACCURACY, RELIABILITY OR CONTENT OF ANY INFORMATION, SOFTWARE, PRODUCTS OR SERVICES PROVIDED THROUGH THE SERVICE OR THE RESULTS TO BE OBTAINED FROM USE OF THE CONTEST SITE. THE CONTEST SITE AND USE OF ANY SOFTWARE ARE PROVIDED ON AN “AS IS” BASIS, WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. SPONSOR HEREBY EXPRESSLY DISCLAIMS, ON ITS OWN BEHALF AND ON BEHALF OF ITS CONTENT PROVIDERS, ALL WARRANTIES OF ANY KIND, OTHER THAN THOSE WHICH ARE IMPLIED BY AND INCAPABLE OF EXCLUSIONS, RESTRICTION OR MODIFICATION UNDER THE LAWS APPLICABLE TO THIS AGREEMENT. THE PLAYER’S SOLE REMEDY FOR ANY DAMAGES CAUSED OR ALLEGEDLY CAUSED BY ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION, OR OTHER CAUSE, SHALL BE TO TERMINATE THE PLAYER’S ACCOUNT. IN NO EVENT WILL COMPANY OR ANY PERSON OR ENTITY INVOLVED IN CREATING, PRODUCING OR DISTRIBUTING THE CONTEST SITE OR ANY SOFTWARE OR CONTENT BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE USE OF OR INABILITY TO USE THE CONTEST SITE, SOFTWARE, OR CONTENT OR OUT OF THE BREACH OF ANY WARRANTY OR ANY OTHER CAUSE.
      </p>

      <p>
        YOU EXPRESSLY UNDERSTAND AND AGREE THAT SPONSOR SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF SPONSOR HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM: (I) THE USE OR THE INABILITY TO USE THE SPONSOR CONTEST SITE AND/OR PARTICIPATE IN THE SPONSOR CONTESTS; (II) THE COST OF PROCUREMENT OF SUBSTITUTE GOODS AND SITE RESULTING FROM ANY GOODS, DATA, INFORMATION OR SERVICES PURCHASED OR OBTAINED OR MESSAGES RECEIVED OR TRANSACTIONS ENTERED INTO THROUGH OR FROM THE SPONSOR SITE; (III) UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (IV) STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON THE SPONSOR SITE; OR (V) ANY OTHER MATTER RELATING TO THE SPONSOR SITE OR OPERATION OF THE SPONSOR CONTESTS. IN NO EVENT SHALL SPONSOR’S TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION (WHETHER IN CONTRACT, TORT (INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE), OR OTHERWISE) EXCEED THE AMOUNT PAID BY YOU, IF ANY, FOR ACCESSING THE CONTEST SITE.
      </p>

      <p>
        SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU. IF ANY OF THE EXCLUSIONS SET FORTH IN THIS SECTION IS DETERMINED BY A COURT OF COMPETENT JURISDICTION TO BE UNENFORCEABLE, THEN ALL SUCH EXPRESS, IMPLIED AND STATUTORY WARRANTIES SHALL BE LIMITED IN DURATION FOR A PERIOD OF THIRTY (30) DAYS AFTER THE DATE ON WHICH YOU FIRST ACCESS THE SITE, AND NO WARRANTIES SHALL APPLY AFTER SUCH PERIOD.
      </p>

      <h3>
        24. Indemnification:
      </h3>

      <p>
        PLAYER AGREES TO BE ENTIRELY RESPONSIBLE FOR MAINTAINING THE CONFIDENTIALITY OF YOUR PASSWORD AND ACCOUNT. FURTHERMORE, YOU ARE ENTIRELY RESPONSIBLE FOR ANY AND ALL ACTIVITIES WHICH OCCUR UNDER YOUR ACCOUNT.
      </p>

      <p>
        Player agrees to defend, indemnify and hold harmless Sponsor, its parents, affiliates, Content Providers, and Merchants and their respective managers, directors, officers, employees and agents from and against all claims, causes of actions, damages, and related expenses, including reasonable attorneys’ fees, arising out of the Player’s use of the Contest Site or the Player’s Account.
      </p>

      <h3>
        25. Notices and Business Address:
      </h3>

      <p>
        Sponsor may give notices to Player, at Sponsor’s option, by posting a message on the Contest Site, by electronic or conventional mail or by any other means by which Player obtains actual knowledge thereof. Notices by Player to Sponsor must be given via electronic or conventional mail.
      </p>

      <p>
        Notices to Sponsor via electronic mail must be sent to
        {" "}

        <a href="mailto:support@derbywars.com" rel="noopener noreferrer" target="_blank">
          support@derbywars.com
        </a>

        {"." /* eslint-disable-line react/jsx-curly-brace-presence */ }
      </p>

      <p>
        Notices to Sponsor via conventional mail must be sent to:
      </p>

      <p>
        {window.env.brandName}

        , c/o Horse Racing Lab, LLC

        <br />

        714 W. Main Street

        <br />

        Louisville, KY 40202

        <br />

        Attention: Support.
      </p>

      <p>
        Notices by a Player to Sponsor will not change the terms of this Agreement or any Rules.
      </p>

      <h3>
        26. Termination:
      </h3>

      <p>
        Sponsor may terminate this Agreement and the Player’s Account at any time, with or without cause. In the event that the Player is dissatisfied with the Contest Site for any reason whatsoever at any time, the only right available to the Player is to terminate the Player’s Account and this Agreement by providing notice to Sponsor. Sponsor may suspend or terminate Player’s Account, without notice, in the event of any breach by the Player of this Agreement or any Rules or for other conduct by the Player which Company, in its sole discretion, considers to be unacceptable. Suspension or termination of a Player’s Account means that the Contest Site will no longer be accessible to the Player. Sponsor shall not be responsible for any consequences to Player resulting from lack of Player access. Suspension or termination of a Player’s Account by Sponsor also terminates the Sponsor’s license to use any software and/or content provided by Sponsor. All agreements made in this Agreement which by their terms are to be performed or observed after termination, including, without limitation, those agreements made under the section headings “User Account Responsibility And Fees”, “User Conduct”, “Disclaimers And Limitation Of Liability”, “Indemnification”, and “Use Of User Information” shall remain in full force and effect and shall survive the termination of the Player’s Account and this Agreement, whether by Sponsor or the Player.
      </p>

      <h3>
        27. Use Of Player Information:
      </h3>

      <p>
        Sponsor shall have the right to use, for such purposes as are described in the Company’s privacy policy, any information provided by the Player or regarding the Player’s access to or use of the Contest Site. Players are prohibited from using another person’s Player information for any business or commercial purposes.
      </p>

      <h3>
        28. Miscellaneous; Governing Law:
      </h3>

      <p>
        This Agreement, together with all applicable Rules, constitute the entire and only agreements between the Sponsor and the Player with respect to the Contest Site and products and services provided by Sponsor, and supersede all other communications and agreements with respect to the subject matter thereof. The Sponsor reserves the right to modify this Agreement and the Rules from time-to-time in its sole discretion. The provisions of this Agreement are for the benefit of Sponsor, its affiliates, Content Providers, and Merchants and their respective managers, directors, officers, employees, agents and licensors and, as such, each shall have the right to assert and enforce such provisions directly on its own behalf.
      </p>

      <p>
        With regards to processing/billing, all disputes will be resolved in the country used for merchant processing.
      </p>

      <p>
        This Agreement shall be governed by and construed under the laws of the Commonwealth of Kentucky and England and Wales without regard to its conflict of laws principles, and the exclusive forums for resolution of any disputes arising under this Agreement shall be the state and federal courts located in Kentucky. If any provision of this Agreement is determined to be invalid, all other provisions shall remain in full force and effect. No waiver of any breach or default hereunder shall be deemed to be a waiver of any preceding or subsequent breach or default. The section headings used herein are for convenience only and shall not be given any legal import.
      </p>

      <h3>
        29. Dormant and abandoned accounts:
      </h3>

      <p>
        All DerbyWars accounts are considered active if they have one transaction per year.  If the account has no activity after 3 years, and after attempts to reach the account owner, there will be a $2.99 monthly dormant account fee charged to maintain the account.
      </p>

      <p>
        If there is no activity after 5 years, the account will be considered inactive and abandoned. At this point, a check will be processed and funds will be returned to the address on file, less administrative fees. The abandonment process is subject to a $20 administrative fee. If the check is returned, then the funds will be escheated to the state of North Dakota within 180-days.
      </p>
    </div>
  );
});
